<div class="featured-product-icon"
     [ngClass]="{
        'featured-product-icon--new': config.newProduct,
        'featured-product-icon--inactive': !url
      }"
>
    <a  target="_blank"
        [href]="url"
        class="featured-product-icon__top">
        <div *ngIf="config.newProduct"
             class="featured-product-icon__new-badge">
            {{ 'NEXT_OTHER_PRODUCTS.NEW' | translate }}
        </div>
        <div class="featured-product-icon__icon">
            <img [src]="config.iconSrc" alt="">
        </div>
        <div class="featured-product-icon__name"
             [innerHTML]="config.name | translate | safeHtml"></div>
    </a>

    <a class="btn btn--secondary featured-product-icon__button"
       [href]="url"
       target="_blank"
    >
        {{ 'FEATURED_PRODUCTS.GO_TO_PRODUCT' | translate }}
    </a>
</div>
